import { Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { formatText } from "../../utils";

const STATUS_COLORS = {
  COMPLETED: "#4FAD5B",
  ONGOING: "#F59E0B",
  PLANNED: "#0092CC",
  STALLED: "#D92D20",
};

function PlannedCard() {
   
  const url = "api/v2/dashboard/getAllDashboardData";
  const data = useSelector((state) => state.fetch.data[url] || []);


  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full">
      <div className="flex flex-wrap items-stretch gap-[1.25rem] w-full">
 
      {data?.projectData &&
        data?.projectData?.map((item, index) => {
          const statusColor =
            STATUS_COLORS[item?.title?.toUpperCase()] || "#050505";

          return (
            <>
            <div key={index} className="flex-1 min-w-[10rem]">
            <div
              className="text-[.875rem] font-[400] font-roboto"
              style={{ color: statusColor }}
            >
              {formatText(item?.title)}
            </div>
            <div className="mt-[2rem] flex justify-between items-center">
              <span
                className="font-interSans text-[1.5rem] font-[500]"
                style={{ color: statusColor }}
              >
                {item?.count}
              </span>
              <span
                className="flex items-center font-interSans text-[.875rem] font-[500]"
                style={{ color: statusColor }}
              >
                {item?.percentage}%
              </span>
            </div> 
          </div> 
          {index !== data?.projectData?.length - 1 && ( 
           <span className="lg:h-[5rem] h-0 lg:w-0 w-full lg:border-l border-b border-[#D6E1F5] lg:mx-[2.5rem] "> 
           </span>
            )}
          </>
          );
        })}
    </div>
    </div>
  );
}

export default PlannedCard;
